import React, { useEffect, useState } from 'react';
import { useHistory } from "react-router-dom";
import {
	Container,
	Grid,
	Header,
	Image,
	Form,
	Dropdown,
	Table,
	Button,
	Accordion,
	Modal,
} from 'semantic-ui-react';
import {
	PULL_ARCHIVE_ERROR,
	PULL_ARCHIVE_LOADING,
	PULL_ARCHIVE_SUCCESS,
} from '../store/types';
import EventService from '../services/EventService';
import { useTitle, useMount } from 'react-use';
import { useSelector, useDispatch } from 'react-redux';
import _ from 'lodash';
import MainMenu from './Menu';
import Logo from '../assests/logo.png';
import { fetchData } from '../store/actions/ArchiveDuplicate';
import { toast } from 'react-toastify';
import ExportButton from './ExportButton';
import ExportButtonDuplicates from './ExportButtonDuplicates';
import { format } from 'date-fns';

let options = {
	timeZone: 'Etc/UTC',
	year: 'numeric',
	month: 'numeric',
	day: 'numeric',
	//    hour: 'numeric',
	//    minute: 'numeric',
	//    second: 'numeric',
};

let formatter = new Intl.DateTimeFormat("en-US", options);


function Duplicados() {
	const history = useHistory();
	const dispatch = useDispatch();
	const [open, setOpen] = useState(false);
	const [event, setEvent] = useState(null);
	const [confirm, setConfirm] = useState(null);
	const [removing, setRemoving] = useState(false);
	const [updating, setUpdating] = useState({
		duplicateState: 'Duplicado',
	});
	const [SelectedList, setArrayListed] = useState([]);
	const [SelectedListToNotDuplicates, setArrayListedToNotDuplicates] = useState([]);
	const [array, setArray] = useState([]);
	const auth = useSelector((state) => state.auth);
	const events = useSelector((state) => state.archive.data);
	//const duplicates = useSelector((state) => state.duplicates.duplicateData);
	const [data, setData] = useState(null);
	const [data2, setData2] = useState(null);
	const [filter, setFilter] = useState({
		entity: '',
		typeOfEntity: '',
		//duplicateState: 'Posible Duplicado',
		duplicateState: '',
		gender: '',
		age: '',
		municipality: '',
		time: '',
		date: '',
	});
	const [order, setOrder] = useState({
		type: 'asc',
		column: 'event_id',
	});

	useTitle('Proyecto CARA | Duplicados');
	useMount(() => dispatch(fetchData(auth)));

	useEffect(() => {
		const conditions = Object.create(null);
		if (filter.entity) {
			conditions.entidad = filter.entity;
		}

		if (filter.typeOfEntity) {
			conditions.tipo_de_entidad = filter.typeOfEntity;
		}

		if (filter.duplicateState) {
			conditions.estado_duplicado = filter.duplicateState;
		}

		if (filter.gender) {
			conditions.genero = filter.gender;
		}

		if (filter.age) {
			conditions.edad = filter.age;
		}

		if (filter.municipality) {
			conditions.municipio = filter.municipality;
		}

		if (filter.time) {
			conditions.hora_evento = filter.time;
		}

		if (filter.date) {
			conditions.fecha_evento = filter.date;
		}

		if (events) {
			const subset = _.filter(events, conditions);
			let ordered;
			if (order.column === 'fecha_evento') {
				ordered = _.orderBy(subset, ['fecha'], [order.type]);
			} else {
				ordered = _.orderBy(subset, [order.column], [order.type]);
			}

			setData(_.filter(ordered, conditions));
		}
	}, [
		events,
		order,
		filter.entity,
		filter.typeOfEntity,
		filter.duplicateState,
		filter.gender,
		filter.age,
		filter.municipality,
		filter.time,
		filter.date,
	]);

	useEffect(() => {
		if (events) {
			const dataset = _.map(events, (r) => {
				return {
					sex: r.sex,
					genero: r.genero,
					genero_otro: r.genero_otro,
					embarazada: r.embarazada,
					semanas_embarazo: r.semanas_embarazo,
					edad: r.edad,
					fecha_evento: formatter.format(new Date(r.fecha_evento)),
					hora_evento: r.hora_evento,
					barrio_generic: r.barrio_generic,
					lugar: r.lugar,
					otherPlace: r.otherPlace,
					municipio: r.municipio,
					zipCode: r.zipCode,
					longitude_generic: r.longitude_generic,
					latitude_generic: r.latitude_generic,
					isThreshingWasUsed: r.isThreshingWasUsed,
					istestresult: r.istestresult,
					naloxona: r.naloxona,
					naloxona_dosis: r.naloxona_dosis,
					via_naloxona: r.via_naloxona !== null ? r.via_naloxona.toString() : "",
					dosis_intranasal: r.dosis_intranasal,
					dosis_intramuscular: r.dosis_intramuscular,
					administrador_naloxona: r.administrador_naloxona,
					opioides_recetados: r.opioides_recetados,
					opioides: r.opiodes !== null ? r.opiodes.toString() : "",
					opioides_otro: r.opioides_otro,
					other_substance: r.other_substance,
					other_substance_especifique: r.other_substance_especifique,
					opiodies_lugar: r.opiodies_lugar,
					sintomas_sobredosis: r.sintomas_sobredosis !== null ? r.sintomas_sobredosis.toString() : "",
					other_symtoms_overdose: r.other_symtoms_overdose,
					estado_persona: r.estado_persona !== null ? r.estado_persona.toString() : "",
					traslado: r.traslado,
					traslado_otro: r.traslado_otro,
					descripcion_evento: r.descripcion_evento,
					residente: r.residente,
					pais: r.pais,
					estado: r.estado,
					pernocta: r.pernocta,
					formal_treatment: r.formal_treatment,
					instituciones: r.instituciones !== null ? r.instituciones.toString() : "",
					especifique_instituciones: r.especifique_instituciones,
					estrategia_de_reduccion: r.estrategia_de_reduccion !== null ? r.estrategia_de_reduccion.toString() : "",
					especifique_estrategia: r.especifique_estrategia,
					form_responsible: r.form_responsible,
					proveedor_naloxona: r.proveedor_naloxona,
					proveedor_naloxona_otro: r.proveedor_naloxona_otro,
					father_initial: r.father_initial,
					mother_initial: r.mother_initial,
					father_dob: r.father_dob,
					month_of_birth: r.month_of_birth,
					nombre: r.nombre,
					apellido: r.apellido,
					telefono: r.telefono,
					email: r.email,
					tipo_de_entidad: r.tipo_de_entidad,
					entidad: r.entidad,
					need_naloxone: r.need_naloxone,
					estado_duplicado: r.duplicateState,
					fecha_creacion_evento: formatter.format(new Date(r.created_date)),
					editor: r.editedBy,
					fecha_edicion_evento: r.updated_date !== null ? formatter.format(new Date(r.updated_date)) : "",
				};
			});

			setArray(dataset);
		}
	}, [events]);

	// const update = (r) => {
	// 	setOpen(true);
	// 	setEvent(r);
	// };


	const reevaluardatos = () => {

		EventService.reevaluarEvent_New()
			.then((res) => {
				//console.log(res);
			})
			.catch((error) => {
				dispatch({
					type: PULL_ARCHIVE_ERROR,
					payload: error,
				});
				refresh();
				EventService.logError({ message: error.message, stack: error.stack });
			});

		// navigate('/duplicados');
		//window.location = window.location;
		//window.location.replace("/duplicados")
		//setData(null);
	}


	const refresh = () => {
		history.replace("/empty");
		setTimeout(() => {
			history.replace("/duplicados");
		}, 10);
	};


	function onItemCheck(e, event_id) {
		//For Duplicates

		if (e.target.checked) {

			if (!SelectedList.includes(event_id)) {
				//checking weather array contain the id
				SelectedList.push(event_id); //adding to array because value doesnt exists
				SelectedListToNotDuplicates.splice(SelectedListToNotDuplicates.indexOf(event_id), 1); //deleting
			}
		} else {
			if (SelectedList.includes(event_id)) {
				SelectedList.splice(SelectedList.indexOf(event_id), 1); //deleting
			}
		}

		// console.log(SelectedList);
		// console.log(SelectedListToNotDuplicates);
	}








	function onItemCheckForNotDuplicates(e, event_id) {
		//For Not Duplicates
		//console.log(e.target.checked)
		if (e.target.checked === true) {
			if (!SelectedListToNotDuplicates.includes(event_id)) {
				//checking weather array contain the id
				SelectedListToNotDuplicates.push(event_id); //adding to array because value doesnt exists
				SelectedList.splice(SelectedList.indexOf(event_id), 1); //deleting
			}
		} else {
			if (SelectedListToNotDuplicates.includes(event_id)) {
				SelectedListToNotDuplicates.splice(SelectedListToNotDuplicates.indexOf(event_id), 1); //deleting
			}
		}
		// console.log(SelectedList);
		// console.log(SelectedListToNotDuplicates);
	}

	const renderCheckbox = (event_id, numero_estado_duplicado) => {
		if (typeof event !== 'undefined' && event != null) {
			if (event.event_id === event_id) {
				return <span></span>;
			} else {



				//wmena 03/29/2023
				if (numero_estado_duplicado === 1) {
					if (!SelectedList.includes(event_id)) {
						//checking weather array contain the id
						SelectedList.push(event_id); //adding to array because value doesnt exists
					}
				}
				return (
					<input
						type="radio"
						value={numero_estado_duplicado || false}
						defaultChecked={numero_estado_duplicado === 1 ? true : false}
						className="form-check-input"
						id={"duplicatechk" + event_id}
						name={"duplicatedhk" + event_id}
						onChange={(e) => onItemCheck(e, event_id)}
					/>




				);
			}
		}
	};

	const renderCheckboxForNotDuplicates = (event_id, numero_estado_duplicado) => {
		if (typeof event !== 'undefined' && event != null) {
			if (event.event_id === event_id) {
				return <span></span>;
			} else {


				if (numero_estado_duplicado === 2) {
					if (!SelectedListToNotDuplicates.includes(event_id)) {
						//checking weather array contain the id
						SelectedListToNotDuplicates.push(event_id); //adding to array because value doesnt exists
					}
				}

				return (
					<input
						type="radio"
						value={numero_estado_duplicado || false}
						defaultChecked={numero_estado_duplicado === 2 ? true : false}
						className="form-check-input"
						id={"noduplicatechk" + event_id}
						name={"duplicatedhk" + event_id}
						onChange={(e) => onItemCheckForNotDuplicates(e, event_id)}
					/>
				);
			}
		}
	};


	const update = (r) => {
		//console.log(r);
		setArrayListed([]);
		setArrayListedToNotDuplicates([]);
		setData2(null);
		//console.log({ data2: data2 });

		EventService.duplicateEvents_New(r.event_id)
			.then((res) => {
				//console.log(res);
				setData2(res.data);
				//dispatch({
				//	type: PULL_ARCHIVE_SUCCESS,
				//	payload: res.data,
				//});
			})
			.catch((error) => {
				dispatch({
					type: PULL_ARCHIVE_ERROR,
					payload: error,
				});
				EventService.logError({ message: error.message, stack: error.stack });
			});

		setConfirm(true);
		setEvent(r);
	};

	return (
		<>
			<MainMenu />

			<Modal open={confirm} centered={false} noValidate size="large">
				<Modal.Header>Seleccionar Duplicados</Modal.Header>
				<Modal.Content scrolling>
					{/* <div className="border round mb-10"> */}
					{/* <Container className="mb-40 mt-40"> */}
					<Grid stackable>
						{data2 && data2.length === 0 && (
							<div
								className="txt-center txt-uppercase mt-40"
								style={{ width: '100%' }}
							>
								No se encontraron datos
							</div>
						)}
						{!data2 && (
							<div
								className="txt-center txt-uppercase mt-40"
								style={{ width: '100%' }}
							>
								Cargando Datos...
							</div>
						)}
						{data2 && data2.length > 0 && (
							<>
								<Grid.Row columns={1}>
									<Grid.Column>
										<Table
											striped
											size="small"
											className="small"
											definition
											singleLine
										>
											<Table.Header>
												<Table.Row>
													<Table.HeaderCell
														className="small"
														textAlign="center"
													>
														#
													</Table.HeaderCell>

													<Table.HeaderCell
														className="small"
														textAlign="center"
													>
														Duplicado
													</Table.HeaderCell>
													<Table.HeaderCell
														className="small"
														textAlign="center"
													>
														No Duplicado
													</Table.HeaderCell>
													<Table.HeaderCell className="small">
														Entidad
													</Table.HeaderCell>
													<Table.HeaderCell className="small">
														Tipo de Entidad
													</Table.HeaderCell>
													<Table.HeaderCell
														className="small"
														textAlign="center"
													>
														Género
													</Table.HeaderCell>

													<Table.HeaderCell
														className="small"
														textAlign="center"
													>
														Edad
													</Table.HeaderCell>
													<Table.HeaderCell
														className="small"
														textAlign="center"
													>
														Fecha Evento
													</Table.HeaderCell>
													<Table.HeaderCell
														className="small"
														textAlign="center"
													>
														Hora
													</Table.HeaderCell>
													<Table.HeaderCell
														className="small"
														textAlign="center"
													>
														Municipio
													</Table.HeaderCell>
													{/* <Table.HeaderCell className="small" textAlign="center">
																			Estado Duplicado
																		</Table.HeaderCell> */}
													{/* <Table.HeaderCell /> */}
												</Table.Row>
											</Table.Header>
											<Table.Body>
												{_.map(data2, (e, index) => {
													return (
														<Table.Row key={e.doc + e.event_id.toString()} className="small">
															<Table.Cell textAlign="center">
																{/* {index + 1} */}
																{e.event_id}{' '}
															</Table.Cell>

															<Table.Cell>
																{renderCheckbox(e.event_id, e.numero_estado_duplicado)}
															</Table.Cell>
															<Table.Cell>
																{renderCheckboxForNotDuplicates(e.event_id, e.numero_estado_duplicado)}
															</Table.Cell>
															<Table.Cell>{e.entidad}</Table.Cell>
															<Table.Cell>{e.tipo_de_entidad}</Table.Cell>
															<Table.Cell textAlign="center">
																{' '}
																{e.genero}
															</Table.Cell>
															<Table.Cell textAlign="center">
																{' '}
																{e.edad}
															</Table.Cell>
															<Table.Cell textAlign="center">
																{' '}
																{formatter.format(new Date(e.fecha_evento))}
															</Table.Cell>
															<Table.Cell textAlign="center">
																{' '}
																{e.hora_evento}
															</Table.Cell>
															<Table.Cell textAlign="center">
																{' '}
																{e.municipio}
															</Table.Cell>
															{/* <Table.Cell textAlign="center"> {e.estado_duplicado}</Table.Cell> */}
														</Table.Row>
													);
												})}
											</Table.Body>
										</Table>
									</Grid.Column>
								</Grid.Row>
							</>
						)}
					</Grid>
				</Modal.Content>
				<Modal.Actions>
					{data2 && data2.length === 0 && (
						<div
							className="txt-center txt-uppercase mt-40"
							style={{ width: '100%' }}
						>
							No se encontraron datos
						</div>
					)}
					{!data2 && (
						<div
							className="txt-center txt-uppercase mt-40"
							style={{ width: '100%' }}
						>
							Cargando Datos...
						</div>
					)}
					{data2 && data2.length > 0 && (
						<>
							<ExportButtonDuplicates data={data2} />
						</>
					)}

					<Button
						content="Cerrar"
						onClick={() => {
							setConfirm(false);
							setEvent(null);
						}}
					/>
					<Button
						type="submit"
						color="orange"
						content="Actualizar Duplicados"
						onClick={() => {
							//console.log(data2);

							if (SelectedList.length > 0) {
								SelectedList.forEach((id) => {
									//console.log(id);

									EventService.updateToDuplicate_New(id)
										.then((res) => {
											dispatch(fetchData(auth));
											toast.success(
												'El  evento  ' +
												id +
												' ha sido actualizado como duplicado'
											);
										})
										.catch((error) => {
											console.log(error);
											toast.error('Error actualizando evento ' + id);
											EventService.logError({ message: error.message, stack: error.stack });
										});

								})
							};

							if (SelectedListToNotDuplicates.length > 0) {
								SelectedListToNotDuplicates.forEach((id) => {
									//console.log(id);

									EventService.updateToNotDuplicate_New(id)
										.then((res) => {
											dispatch(fetchData(auth));
											toast.success(
												'El  evento  ' +
												id +
												' ha sido actualizado como no duplicado'
											);
										})
										.catch((error) => {
											console.log(error);
											toast.error('Error actualizando evento no duplicado ' + id);
											EventService.logError({ message: error.message, stack: error.stack });
										});
								})
							};

							setConfirm(false);
							setEvent(null);
						}}
					/>
				</Modal.Actions>
			</Modal>

			<Container className="mb-40 mt-40">
				<Grid stackable>
					<Grid.Row columns={1}>
						<Grid.Column>
							<div
								style={{
									display: 'flex',
									alignItems: 'center',
									marginBottom: '10px',
								}}
							>
								{/* <Image
									src={Logo}
									style={{ marginRight: '10px', width: '40px' }}
								/> */}
								<div>
									<div style={{ fontWeight: 'bold' }}>
										Gobierno de Puerto Rico
									</div>
									<div>
										Administración de Servicios de Salud Mental y Contra la
										Adicción
									</div>
								</div>
							</div>
							<div className="clearfix" />
							<Header as="h1">
								Duplicados
								<Header.Subheader>
									Archivo de eventos de posibles sobredosis por consumo de
									opiáceos y administración de naloxona con posibilidad de estar
									duplicados.
								</Header.Subheader>
							</Header>
							<p className="small justify">
								Esta tabla muestra los posibles duplicados de{' '}
								<span className="strong">
									{' '}
									eventos de posibles sobredosis de opioides y el uso de
									naloxona
								</span>{' '}
								duplicados en el sistema. Se utiliza la información de tipo de
								entidad, genero, edad, fecha de evento, hora y municipio para
								identificar el posible duplicado. La columna titulada duplicados
								indica el numero de eventos que tienen un perfil similiar. El
								usuario puede evaluar el caso y confirmar cuales si alguno son
								duplicados. Los cambios realizados en esta tabla se reflejan en
								el area de archivo
							</p>
						</Grid.Column>
					</Grid.Row>
					<Grid.Row columns={1}>
						<Grid.Column
							style={{ display: 'flex', justifyContent: 'flex-end' }}
						>
						</Grid.Column>
					</Grid.Row>


					<>
						<Grid.Row columns={1}>
							<Grid.Column>
								<ExportButton data={array} />

								<Button

									color="grey"
									size="small"
									icon="refresh"
									content="Reevaluar Datos"
									onClick={() => reevaluardatos()}

								/>

							</Grid.Column>
						</Grid.Row>
						<Grid.Row columns={1}>
							<Grid.Column>
								<Accordion
									fluid
									styled
									exclusive={false}
									panels={[
										{
											key: 0,
											title: {
												content: 'Filtrar Datos',
											},
											content: {
												content: (
													<Form size="small">
														<Form.Group widths="equal">
															<Form.Field
																className="hide"
																name="duplicateState"
																label="duplicateState"
																placeholder="Seleccionar..."
																control={Dropdown}
																fluid
																search
																selection
																clearable
																value={filter.duplicateState}
																onChange={(e, { value }) => {
																	setFilter({
																		...filter,
																		duplicateState: value,
																	});
																}}
																noResultsMessage="No hubo resultados"
																options={_.map(
																	_.filter(
																		_.uniqBy(events, 'estado_duplicado'),
																		(o) => {
																			return o.estado_duplicado !== '';
																		}
																	),
																	(item) => {
																		return {
																			key: item.estado_duplicado,
																			text: item.estado_duplicado,
																			value: item.estado_duplicado,
																		};
																	}
																)}
															/>
															<Form.Field
																name="entity"
																label="Entidades"
																placeholder="Seleccionar..."
																control={Dropdown}
																fluid
																search
																selection
																clearable
																value={filter.entity}
																onChange={(e, { value }) => {
																	setFilter({ ...filter, entity: value });
																}}
																noResultsMessage="No hubo resultados"
																options={_.map(
																	_.filter(
																		_.uniqBy(events, 'entidad'),
																		(o) => {
																			return o.entidad !== '';
																		}
																	),
																	(item) => {
																		return {
																			key: item.entidad,
																			text: item.entidad,
																			value: item.entidad,
																		};
																	}
																)}
															/>
															<Form.Field
																name="typeOfEntity"
																label="Tipo De Entidad"
																placeholder="Seleccionar..."
																control={Dropdown}
																fluid
																search
																selection
																clearable
																value={filter.typeOfEntity}
																onChange={(e, { value }) => {
																	setFilter({
																		...filter,
																		typeOfEntity: value,
																	});
																}}
																noResultsMessage="No hubo resultados"
																options={_.map(
																	_.filter(
																		_.uniqBy(events, 'tipo_de_entidad'),
																		(o) => {
																			return o.tipo_de_entidad !== '';
																		}
																	),
																	(item) => {
																		return {
																			key: item.tipo_de_entidad,
																			text: item.tipo_de_entidad,
																			value: item.tipo_de_entidad,
																		};
																	}
																)}
															/>
															<Form.Field
																name="gender"
																label="Género"
																placeholder="Seleccionar..."
																control={Dropdown}
																fluid
																search
																selection
																clearable
																value={filter.gender}
																onChange={(e, { value }) => {
																	setFilter({ ...filter, gender: value });
																}}
																noResultsMessage="No hubo resultados"
																options={_.map(
																	_.filter(
																		_.uniqBy(events, 'genero'),
																		(o) => {
																			return o.genero !== '';
																		}
																	),
																	(item) => {
																		return {
																			key: item.genero,
																			text: item.genero,
																			value: item.genero,
																		};
																	}
																)}
															/>
															<Form.Field
																name="age"
																label="Edad"
																placeholder="Seleccionar..."
																control={Dropdown}
																fluid
																search
																selection
																clearable
																value={filter.age}
																onChange={(e, { value }) => {
																	setFilter({ ...filter, age: value });
																}}
																noResultsMessage="No hubo resultados"
																options={_.map(
																	_.filter(_.uniqBy(events, 'edad'), (o) => {
																		return o.edad !== '';
																	}),
																	(item) => {
																		return {
																			key: item.edad,
																			text: item.edad,
																			value: item.edad,
																		};
																	}
																)}
															/>
														</Form.Group>
														<Form.Group widths="equal">
															<Form.Field
																name="municipality"
																label="Municipio"
																placeholder="Seleccionar..."
																control={Dropdown}
																fluid
																search
																selection
																clearable
																value={filter.municipality}
																onChange={(e, { value }) => {
																	setFilter({
																		...filter,
																		municipality: value,
																	});
																}}
																noResultsMessage="No hubo resultados"
																options={_.map(
																	_.filter(
																		_.uniqBy(events, 'municipio'),
																		(o) => {
																			return o.municipio !== '';
																		}
																	),
																	(item) => {
																		return {
																			key: item.municipio,
																			text: item.municipio,
																			value: item.municipio,
																		};
																	}
																)}
															/>
															<Form.Field
																name="time"
																label="Hora"
																placeholder="Seleccionar..."
																control={Dropdown}
																fluid
																search
																selection
																clearable
																value={filter.time}
																onChange={(e, { value }) => {
																	setFilter({ ...filter, time: value });
																}}
																noResultsMessage="No hubo resultados"
																options={_.map(
																	_.orderBy(
																		_.filter(
																			_.uniqBy(events, 'hora_evento'),
																			(o) => {
																				return o.hora_evento !== '';
																			}
																		),
																		['hora_evento'],
																		['asc']
																	),
																	(item) => {
																		return {
																			key: item.hora_evento,
																			text: item.hora_evento,
																			value: item.hora_evento,
																		};
																	}
																)}
															/>
															<Form.Field
																name="date"
																label="Fecha de Evento"
																placeholder="Seleccionar..."
																control={Dropdown}
																fluid
																search
																selection
																clearable
																value={filter.date}
																onChange={(e, { value }) => {
																	setFilter({ ...filter, date: value });
																}}
																noResultsMessage="No hubo resultados"
																options={_.map(
																	_.filter(
																		_.uniqBy(events, 'fecha_evento'),
																		(o) => {
																			return o.fecha_evento !== '';
																		}
																	),
																	(item) => {
																		return {
																			key: item.fecha_evento,
																			text: format(
																				item.fecha_evento,
																				'MM/DD/YYYY'
																			),
																			value: item.fecha_evento,
																		};
																	}
																)}
															/>
														</Form.Group>
													</Form>
												),
											},
										},
										{
											key: 1,
											title: {
												content: 'Ordenar Datos',
											},
											content: {
												content: (
													<Form size="small">
														<Form.Group widths="equal">
															<Form.Field
																label="Tipo"
																control={Dropdown}
																fluid
																selection
																value={order.type}
																onChange={(e, { value }) => {
																	setOrder({ ...order, type: value });
																}}
																options={[
																	{
																		key: 'asc',
																		text: 'Ascendente',
																		value: 'asc',
																	},
																	{
																		key: 'desc',
																		text: 'Descendente',
																		value: 'desc',
																	},
																]}
															/>
															<Form.Field
																label="Columna"
																control={Dropdown}
																fluid
																selection
																value={order.column}
																onChange={(e, { value }) => {
																	setOrder({ ...order, column: value });
																}}
																options={[
																	{
																		key: 'Entidad',
																		text: 'Entidad',
																		value: 'entidad',
																	},
																	{
																		key: 'Tipo_de_Entidad',
																		text: 'Tipo de Entidad',
																		value: 'tipo_de_entidad',
																	},
																	{
																		key: 'Género',
																		text: 'Género',
																		value: 'genero',
																	},
																	{
																		key: 'Edad',
																		text: 'Edad',
																		value: 'edad',
																	},
																	{
																		key: 'Municipio',
																		text: 'Municipio',
																		value: 'municipio',
																	},
																	{
																		key: 'Hora',
																		text: 'Hora',
																		value: 'hora_evento',
																	},
																	{
																		key: 'Fecha',
																		text: 'Fecha de Evento',
																		value: 'fecha_evento',
																	},
																]}
															/>
														</Form.Group>
													</Form>
												),
											},
										},
									]}
								/>
							</Grid.Column>
						</Grid.Row>
					</>

					{data && data.length > 0 && (
						<>

							<Grid.Row columns={1}>
								<Grid.Column>
									<Table
										striped
										size="small"
										className="small"
										definition
										singleLine
									>
										<Table.Header>
											<Table.Row>
												<Table.HeaderCell className="small" textAlign="center">
													#
												</Table.HeaderCell>
												<Table.HeaderCell className="small" textAlign="center">
													Duplicados
												</Table.HeaderCell>
												<Table.HeaderCell className="small">
													Entidad
												</Table.HeaderCell>
												<Table.HeaderCell className="small" textAlign="center">
													Tipo de Entidad
												</Table.HeaderCell>
												<Table.HeaderCell className="small" textAlign="center">
													Género
												</Table.HeaderCell>
												<Table.HeaderCell className="small" textAlign="center">
													Edad
												</Table.HeaderCell>
												<Table.HeaderCell className="small" textAlign="center">
													Municipio
												</Table.HeaderCell>
												<Table.HeaderCell className="small" textAlign="center">
													Hora
												</Table.HeaderCell>
												<Table.HeaderCell className="small" textAlign="center">
													Fecha de Evento
												</Table.HeaderCell>
												<Table.HeaderCell className="small" textAlign="center">
													Estado Duplicado
												</Table.HeaderCell>
												<Table.HeaderCell />
											</Table.Row>
										</Table.Header>
										<Table.Body>
											{_.map(data, (e, index) => {
												return (
													<Table.Row key={e.doc} className="small">
														<Table.Cell textAlign="center">
															{/* {index + 1} */}
															{e.event_id}
														</Table.Cell>
														<Table.Cell>{e.duplicatescount}</Table.Cell>
														<Table.Cell>{e.entidad}</Table.Cell>
														<Table.Cell textAlign="center">
															{e.tipo_de_entidad}
														</Table.Cell>
														<Table.Cell textAlign="center">
															{e.genero}
														</Table.Cell>
														<Table.Cell textAlign="center">{e.edad}</Table.Cell>
														<Table.Cell textAlign="center">
															{e.municipio}
														</Table.Cell>
														<Table.Cell textAlign="center">
															{e.hora_evento}
														</Table.Cell>
														<Table.Cell textAlign="center">
															{e.fecha}
														</Table.Cell>
														{/* <Table.Cell textAlign="center">{ format( e.created_date, 'MM/DD/YYYY')}</Table.Cell> */}
														<Table.Cell textAlign="center">
															{e.estado_duplicado}
														</Table.Cell>
														<Table.Cell textAlign="center">
															{auth.details.role === 'Administrador' && (
																<Button
																	size="mini"
																	icon="pencil"
																	onClick={() => update(e)}
																/>
															)}
															{/* <Button
																size="mini"
																icon="pencil"
																onClick={() => update(e)}
															/> */}
														</Table.Cell>
													</Table.Row>
												);
											})}
										</Table.Body>
									</Table>
								</Grid.Column>
							</Grid.Row>
						</>
					)}

					{data && data.length === 0 && (
						<div
							className="txt-center txt-uppercase mt-40"
							style={{ width: '100%' }}
						>
							No existen datos en su perfil
						</div>
					)}
					{!data && (
						<div
							className="txt-center txt-uppercase mt-40"
							style={{ width: '100%' }}
						>
							Cargando Datos...
						</div>
					)}
				</Grid>
			</Container>
		</>
	);
}

export default Duplicados;
